<template>
  <section>
    <page-header has-return :page="page" @onReturn="$router.go(-1)" />

    <section-title
      icon="fas fa-file-contract"
      content="Información de Escuela"
      container-class="tag-badge-main-info m-0 mb-3"
    />

    <validation-observer ref="validator">
      <div class="row mx-1">
        <div class="col-sm mt-2">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-drop-down
              v-model="filters.academicYear"
              :error="errors[0]"
              :options="collections.academicYears"
              label="Año Fiscal:"
              placeholder="Seleccionar"
              fieldkey="id"
              fieldname="name"
            />
          </validation-provider>
        </div>
        <div class="col-sm mt-2">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-drop-down
              v-model="filters.region"
              :error="errors[0]"
              :custom-error-msg="resources['17004']"
              :options="collections.regions"
              label="Región:"
              placeholder="Seleccionar"
              fieldkey="id"
              fieldname="name"
            />
          </validation-provider>
        </div>
        <div class="col-sm mt-2">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-drop-down
              v-model="filters.municipality"
              :error="errors[0]"
              :custom-error-msg="resources['R160003']"
              :options="collections.municipalities"
              label="Municipio:"
              placeholder="Seleccionar"
              fieldkey="id"
              fieldname="name"
            />
          </validation-provider>
        </div>
      </div>
      <div class="row mx-1 mt-2">
        <div class="col-sm">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-drop-down
              v-model="filters.school"
              :error="errors[0]"
              :custom-error-msg="resources['17006']"
              :options="collections.schools"
              label="Escuela:"
              placeholder="Seleccionar"
              fieldkey="id"
              fieldname="name"
            />
          </validation-provider>
        </div>
        <div class="col-sm d-flex justify-content-end align-self-end">
          <div>
            <action-button
              class="mt-3"
              variant="success"
              text="Generar Certificación"
              @click="create"
            />
          </div>
        </div>
      </div>
    </validation-observer>
  </section>
</template>

<script>
import PageHeader from '@/components/common/page/PageHeader';
import { SectionTitle } from '@/components/pei/shared';
import { ActionButton, CustomDropDown } from '@/components/common';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { helpers, watcherWorkFlow1 } from '@/mixin/filters/general';
import resourcesService from '@/services/resources.js';
import academicYearService from '@/services/academicyear';
import alert from '@/mixin/alert.mixin';

export default {
  name: 'AddCertificationGraduation',
  mixins: [helpers, watcherWorkFlow1, alert],
  components: {
    PageHeader,
    SectionTitle,
    ActionButton,
    CustomDropDown,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      page: {
        icon: 'fas fa-user-edit',
        title: 'Añadir Certificación de Matrícula',
        routes: ['Inicio', 'Estudiante', 'Añadir Certificación de Egreso'],
      },
      resources: [],
    };
  },
  async mounted() {
    this.resources = await resourcesService.LoadValidationMessages([
      '17004',
      '17005',
      '17006',
      'R160003',
      'R160004',
      'R90013',
    ]);

    const { data: previousYear } =
      await academicYearService.getPreviousAcademicYear();

    this.collections.academicYears.push({
      id: previousYear.id,
      name: previousYear.description,
      selected: true,
      disabled: true,
    });

    this.filters.academicYear = this.collections.academicYears[0];
  },
  methods: {
    async create() {
      let self = this;
      let isValid = await this.$refs.validator.validate();
      let goToCertification = true;
      if (isValid) {
        await this.$ApiPut('/api/graduation/hascertifications', {
          AcademicYearId: this.filters.academicYear.id,
          RegionId: this.filters.region.id,
          MunicipalityId: this.filters.municipality.id,
          LocationSchoolId: this.filters.school.id,
        }).then(async (response) => {
          if (response.data.value == true) {
            const answer = await alert.methods.ShowCancelModal(
              'Aviso',
              response.data.message,
              'Si',
              'No'
            );
            if (answer) {
              goToCertification = true;
            } else {
              goToCertification = false;
            }
          }
        });

        if (goToCertification == true) {
          await this.$ApiPut('/api/graduation/create', {
            AcademicYearId: this.filters.academicYear.id,
            RegionId: this.filters.region.id,
            MunicipalityId: this.filters.municipality.id,
            LocationSchoolId: this.filters.school.id,
          })
            .then(async (response) => {
              let certificationId = response.data;

              self.$router.push({
                name: 'graduation-information',
                params: {
                  certificationId: certificationId,
                },
              });
            })
            .catch((err) => {
              this.ShowToast('Error', err.response.data.message, 'error');
            });
        }
      } else {
        this.ShowToast(
          this.resources['R90013'],
          this.resources['R160004'],
          this.toastType.Error
        );
      }
    },
  },
};
</script>
